import { computed, inject, watch } from 'vue';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { useBuildSummaryLazyQuery } from '@/graphql/codegen/generated/graphql';
import { app } from '@/bootloader';
import { IKWorkloadBuildDetailsData } from '../../workloads.injectionKeys';

export const useWorkloadViewSummaryDataProvider = (buildId: string) => {
  const coordinatorService = inject(IKCoordinatorsService);
  const coordinatorId = coordinatorService?.selectedCoordinator.value;
  const GQL_useWorkloadSummaryQuery = useBuildSummaryLazyQuery(() => ({
    filter: {
      coordinatorId,
      buildId,
    },
  }));

  watch(
    () => coordinatorService?.selectedCoordinator.value,
    () => {
      GQL_useWorkloadSummaryQuery.load();
    },
    {
      immediate: true,
    },
  );

  const summary = computed(() => GQL_useWorkloadSummaryQuery.result.value?.buildDetails?.buildSummary);
  const result = {
    GQL: GQL_useWorkloadSummaryQuery,
    summary,
  };
  app.provide(IKWorkloadBuildDetailsData, result);

  return result;
};

export const useWorkloadViewSummaryData = () => {
  const res = inject(IKWorkloadBuildDetailsData);
  return res;
};
